import { Layer } from '@/components/LayeringEngine/LayeringEngine.models';
import { ResponsiveImageDimensions } from '@/components/utils/ResponsiveImage/ResponsiveImage.models';
import { HouseConfiguration } from '../api';
import generateITSMedia from './generateITSMedia';

export default (configuration: HouseConfiguration, mediaDimensions: ResponsiveImageDimensions): Layer[] => {
  const layers: Layer[] = [];

  layers.push(
    {
      ID: configuration.sizeID,
      alt: configuration.sizeID,
      media: generateITSMedia(configuration.houseImage, mediaDimensions)
    },
    ...configuration.selections.map(selection => ({
      ID: selection.zoneID,
      alt: selection.zoneID,
      media: generateITSMedia(selection.imageConfiguration, mediaDimensions)
    }))
  );

  return layers;
};
